import React from "react";
import bind from "memoize-bind";
import { Dropdown } from "semantic-ui-react";

export default class TypeaheadInput extends React.PureComponent {
  state = { customValue: null };

  handleChange(event, { value }) {
    this.props.onChange(value);
  }

  handleAddItem(event, { value }) {
    this.setState({ customValue: value });
  }

  render() {
    const {
      value,
      onChange,
      existingValues,
      placeholder = I18n.t("papp.components.TypeaheadInputFormControl.placeholder"),
      noResultsMessage = I18n.t("papp.components.TypeaheadInputFormControl.no_results_message"),
      className,
      fluid,
    } = this.props;
    const { customValue } = this.state;
    const values = (existingValues || []).concat(customValue ? [customValue] : []);
    if (value && !values.includes(value)) {
      values.unshift(value);
    }
    const options = [{ value: "", text: placeholder }].concat(values.map((value) => ({ value, text: value })));

    return (
      <Dropdown
        value={value || ""}
        onChange={bind(this.handleChange, this)}
        onAddItem={bind(this.handleAddItem, this)}
        options={options}
        search
        selection
        allowAdditions
        placeholder={placeholder}
        noResultsMessage={noResultsMessage}
        additionLabel={null}
        className={className}
        fluid={fluid}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/TypeaheadInput.jsx